import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { StepProps, YesNoUnknown } from '../../types';

const Container = styled.div`
  ${tw`flex flex-col h-full`}
`;

const SectionLabel = styled.div`
  ${tw`text-xs font-semibold text-text-secondary uppercase tracking-wider mb-3`}
`;

const Title = styled.h2`
  ${tw`text-xl font-semibold text-text-primary mb-6`}
`;

const OptionsContainer = styled.div`
  ${tw`flex flex-col gap-3 mb-8`}
`;

const OptionButton = styled.button<{ isSelected: boolean }>`
  ${tw`w-full p-4 text-left border-2 rounded-card transition-all flex items-center justify-between`}
  ${props =>
    props.isSelected
      ? tw`border-black bg-pink-50`
      : tw`border-border-default hover:border-border-default`}
`;

const OptionText = styled.span`
  ${tw`font-medium text-text-primary`}
`;

const CheckIcon = styled.div<{ isSelected: boolean }>`
  ${tw`w-6 h-6 rounded-full flex items-center justify-center`}
  ${props => (props.isSelected ? tw`bg-black` : tw`bg-bg-secondary`)}
`;

const ContinueButton = styled.button<{ disabled: boolean }>`
  ${tw`w-full py-4 font-semibold rounded-card mt-auto`}
  ${props =>
    props.disabled
      ? tw`bg-bg-secondary text-text-tertiary cursor-not-allowed`
      : tw`bg-black text-white hover:bg-black-hover`}
`;

const options = [
  { value: YesNoUnknown.YES, label: 'Yes' },
  { value: YesNoUnknown.NO, label: 'No' },
  { value: YesNoUnknown.UNKNOWN, label: "I don't know" },
];

const MechanicalIsCarDriveableStep: React.FC<StepProps> = ({
  formData,
  updateFormData,
  onNext,
}) => {
  const handleSelect = (value: YesNoUnknown) => {
    updateFormData({ isCarDriveable: value });
  };

  const canContinue = !!formData.isCarDriveable;

  return (
    <Container>
      <SectionLabel>DAMAGE DETAILS</SectionLabel>
      <Title>Is the car driveable?</Title>

      <OptionsContainer>
        {options.map(option => (
          <OptionButton
            key={option.value}
            isSelected={formData.isCarDriveable === option.value}
            onClick={() => handleSelect(option.value)}
          >
            <OptionText>{option.label}</OptionText>
            <CheckIcon isSelected={formData.isCarDriveable === option.value}>
              {formData.isCarDriveable === option.value && (
                <FontAwesomeIcon icon={faCheck} size="xs" color="white" />
              )}
            </CheckIcon>
          </OptionButton>
        ))}
      </OptionsContainer>

      <ContinueButton disabled={!canContinue} onClick={onNext}>
        Continue
      </ContinueButton>
    </Container>
  );
};

export default MechanicalIsCarDriveableStep;
